// Field labels may carry HTML or markdown links, which the checkout renders as links.
// Everywhere else prints the label as text, so it shows the link text instead of the markup.
export function fieldLabelText(label: string | null | undefined): string {
  return (label ?? '').replace(/<\/?[a-z][^>]*>/gi, '').replace(/\[([^\]]+)\]\([^)]*\)/g, '$1');
}
